import { setIsLoading } from './set-is-loading';

export const stopLoadingCategory = (categoryId) => setIsLoading('category', categoryId, false);
